module.exports = __webpack_public_path__ + "img/phone.e07247f1.png";